import { useSelector } from 'react-redux';

import { SubscriptionType } from '../constants';
import { selectGeneralSettings } from '../services/selectors';

export const useSubscriptionAlerts = () => {
    const { subscription } = useSelector(selectGeneralSettings);

    const canceledSubscriptionAlertVisible = subscription === SubscriptionType.canceled;

    const notLinkedAlertVisible = subscription === SubscriptionType['not-linked'];

    return { canceledSubscriptionAlertVisible, notLinkedAlertVisible };
};
